var views = ['countries', 'country', 'location', 'questionnaire'];

export default {
    template: '#location-averages',
    data: function () {
        return {
            type: 'countries',
            countryIndex: null,
            locationIndex: null,
            items: window.greenmotion.reports.feedbackByLocation,
            loading: false,
        };
    },
    computed: {
        typeHeading: function () {
            return this.comingView || this.type;
        },
        comingView: function () {
            var index = views.indexOf(this.type);

            return views[index + 1];
        },
    },
    ready: function () {
        // $('.footable').footable({
        //     paginate: false
        // });
    },
    methods: {
        capitalize: function (text) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        },
        nextView: function (index, event) {
            switch (this.type) {
                case 'countries':
                    this.countryIndex = index;
                    event.preventDefault();
                    break;
                case 'country':
                    this.locationIndex = index;
                    event.preventDefault();
                    break;
                case 'location':
                    // event.preventDefault();
                    return;
            }

            var type = views[views.indexOf(this.type) + 1];
            this.type = type;
            this.updateItems(index, type);
            // this.redrawTable();
        },
        previousView: function (index) {
            var type = views[views.indexOf(this.type) - 1];
            this.type = type;
            this.updateItems(index, type);
            // this.redrawTable();
        },
        updateItems: function (index, type) {
            switch (type) {
                case 'countries':
                    this.items = window.greenmotion.reports.feedbackByLocation;
                    break;
                case 'country':
                    this.items = window.greenmotion.reports.feedbackByLocation[this.countryIndex].locations;
                    break;
                case 'location':
                    var newIndex =
                        window.greenmotion.reports.feedbackByLocation[this.countryIndex].locations[this.locationIndex]
                            .id;
                    this.items = [{ averages: [] }];
                    this.loading = true;
                    this.$http({ url: '/api/feedback/' + newIndex, method: 'GET' }).then(
                        function (response) {
                            this.$set('items', response.data);
                            this.$set('loading', false);
                        },
                        function (response) {
                            // error callback
                            this.$set('loading', false);
                        }
                    );
            }
        },
        scoreColour: function (score) {
            if (score > 4) {
                return 'text-success';
            } else if (score >= 2.5) {
                return 'text-warning';
            } else {
                return 'text-danger';
            }
        },
        childCount: function (item) {
            if (item.locations) {
                var count = 0;
                item.locations.forEach(function (location) {
                    count += location.count;
                });

                return '(' + count + ')';
            } else if (item.count) {
                return '(' + item.count + ')';
            }

            return null;
        },
        redrawTable: function () {
            this.$nextTick(function () {
                $('.footable').footable({
                    paginate: false,
                });
                $('.footable').trigger('footable_redraw');
            });
        },
        convertToArrayObject: function (e) {
            var averages = [];
            if (typeof e.averages.forEach == 'function') {
                averages = e.averages;
            } else {
                averages = $.map(e.averages, function (value) {
                    return [value];
                });
            }
            return averages;
        },
        transform: function (items) {
            var exports = [];
            items.forEach(
                function (e, i) {
                    var item = {};
                    item[this.capitalize(this.typeHeading)] =
                        typeof e.name !== 'undefined' ? e.name : e.booking_reference;
                    var averages = this.convertToArrayObject(e);
                    averages.forEach(function (ae) {
                        item[ae.title] = ae.average;
                    });
                    exports.push(item);
                }.bind(this)
            );
            return exports;
        },
        export: function () {
            var exports = this.transform(this.items);
            $('#export-form [name="data"]').val(JSON.stringify(exports));
            $('#export-form').submit();
            //$.post('/api/csv',{data:exports});
        },
    },
};



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/feedback/components/LocationAverages.js